import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/app/hooks/useAuth'

export function AutoLogin() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { signin } = useAuth()

  useEffect(() => {
    const token = searchParams.get('token')
    console.log(token)
    if (token) {
      signin(token)
      setTimeout(() => {
        navigate('/transacoes', { replace: true })
      }, 1000)
    } else {
      navigate('/', { replace: true })
    }
  }, [searchParams, signin, navigate])

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '24px', marginBottom: '10px' }}>⏳</div>
        <div>Fazendo login...</div>
      </div>
    </div>
  )
}
